import { useEffect, useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import { House } from "lucide-react";
import PublicHeader from "../components/PublicChrome/PublicHeader";
import PublicShell from "../components/PublicChrome/PublicShell";
import PublicSiteFooter from "../components/PublicChrome/PublicSiteFooter";
import { mountPublicFonts, PUBLIC_FONT_FAMILY } from "../components/PublicChrome/publicFontFamily";
import {
  NOT_FOUND_ACTIONS,
  NOT_FOUND_DOCUMENT_TITLE,
  NOT_FOUND_EYEBROW,
  NOT_FOUND_LEAD,
  NOT_FOUND_STAGE_DIGITS,
  NOT_FOUND_TEXT_LINKS,
  NOT_FOUND_TITLE,
  notFoundClass,
} from "./notFound404Content";
import "./NotFound404.css";

export default function NotFound404() {
  useEffect(() => {
    const previous = document.title;
    document.title = NOT_FOUND_DOCUMENT_TITLE;
    return () => {
      document.title = previous;
    };
  }, []);

  useLayoutEffect(() => mountPublicFonts(), []);

  return (
    <PublicShell>
      <div className={notFoundClass.page} style={{ fontFamily: PUBLIC_FONT_FAMILY }}>
        <PublicHeader />
        <main className={notFoundClass.hero}>
          <div className={notFoundClass.stage} aria-hidden="true">
            <span className={notFoundClass.teal} />
            <span className={notFoundClass.emerald} />
            <span className={notFoundClass.amber} />
            <span className={notFoundClass.sky} />
            <span className={notFoundClass.digits}>{NOT_FOUND_STAGE_DIGITS}</span>
          </div>
          <span className={notFoundClass.narrowEmerald} aria-hidden="true" />
          <span className={notFoundClass.narrowAmber} aria-hidden="true" />
          <span className={notFoundClass.narrowTeal} aria-hidden="true" />
          <div className={notFoundClass.copy}>
            <p className={notFoundClass.eyebrow}>{NOT_FOUND_EYEBROW}</p>
            <h1 className={notFoundClass.title}>{NOT_FOUND_TITLE}</h1>
            <p className={notFoundClass.lead}>{NOT_FOUND_LEAD}</p>
            <div className={notFoundClass.actions}>
              {NOT_FOUND_ACTIONS.map((action) => (
                <Link
                  key={action.to}
                  to={action.to}
                  className={
                    action.kind === "primary"
                      ? notFoundClass.primary
                      : notFoundClass.secondary
                  }
                >
                  {action.kind === "primary" ? (
                    <House size={20} aria-hidden="true" />
                  ) : null}
                  {action.label}
                </Link>
              ))}
            </div>
            <div className={notFoundClass.links}>
              {NOT_FOUND_TEXT_LINKS.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={notFoundClass.textLink}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </main>
        <PublicSiteFooter />
      </div>
    </PublicShell>
  );
}
